import { handle } from 'redux-pack';
import { assoc } from 'ramda';

import { get } from 'lib/communication';
import createReducer from 'lib/createReducer';

/* Action types */

const LOAD_NEURO_DOCUMENTS = 'myms/neuroDocuments/LOAD_NEURO_DOCUMENTS';

export const actionTypes = { LOAD_NEURO_DOCUMENTS };

/* Action creator(s) */

const loadNeuroDocuments = () => ({
  type: LOAD_NEURO_DOCUMENTS,
  promise: get('/mydocuments'),
});

export const actions = { loadNeuroDocuments };

/* Handlers and the reducer */

const initialState = {
  isLoading: false,
  error: null,
  documents: [],
};

const handleLoadNeuroDocuments = (s, a) =>
  handle(s, a, {
    start: assoc('isLoading', true),
    finish: assoc('isLoading', false),
    failure: assoc('error', a.payload),
    success: preState => ({
      ...preState,
      documents: a.payload,
    }),
  });

export default createReducer(initialState, {
  [LOAD_NEURO_DOCUMENTS]: handleLoadNeuroDocuments,
});
